import { ReactNode } from 'react';
import cn from 'classnames';

interface LabelProps {
  children: ReactNode;
  className?: string;
}

export default function Label({ children, className }: LabelProps) {
  return (
    <span
      className={cn(
        `block text-xs font-medium uppercase leading-none tracking-wider text-light-haiti`,
        className,
      )}
    >
      {children}
    </span>
  );
}
